import _ from 'lodash';
import { FeatureFlags } from '@socrata/platform/feature-flags';
import Environment from 'StorytellerEnvironment';
import type { Layout } from 'react-grid-layout';

/**
 * isLayoutEqual: compares the layout of two different components.
 * We only care about the x, y, h, and w of the layout. All other
 * information is irrelevant.
 */
export const isLayoutEqual = (layout1: Layout, layout2: Layout): boolean => {
  const oldLayout = _.pick(layout1, ['h', 'w', 'x', 'y']);

  const newLayout = _.pick(layout2, ['h', 'w', 'x', 'y']);

  return _.isEqual(oldLayout, newLayout);
};

export const sharedFlexRGLProps = {
  className: 'grid-layout',
  cols: { lg: 12, md: 12, sm: 12, xs: 12, xxs: 12 },
  rowHeight: 30,
  containerPadding: [20, 0],
  margin: [20, 0],
};

/**
 * Minimum height, in grid rows, for a text block. The editor clamps a text block's
 * broadcast layout height to this (see RichTextEditor `_shouldBroadcastHeightChange`),
 * so it is also the floor the view must use to stay in parity. Shared here so the
 * editor and the view can't drift apart.
 */
export const MIN_LAYOUT_HEIGHT = 2;

/**
 * Converts a measured pixel height to react-grid-layout rows, matching how the editor
 * sizes text blocks: round to the nearest row and clamp to {@link MIN_LAYOUT_HEIGHT}.
 */
export const pixelsToLayoutRows = (pixels: number): number =>
  Math.max(Math.round(pixels / sharedFlexRGLProps.rowHeight), MIN_LAYOUT_HEIGHT);

export const isFlexibleStory = (): boolean => {
  return (
    FeatureFlags.valueOrDefault('enable_flexible_story_layout', true) &&
    Environment.STORY_DATA?.isFlexibleStory
  );
};
